import { createStore } from 'vuex'

// Load saved theme from localStorage, default to 'light'
const savedTheme = (typeof localStorage !== 'undefined' && localStorage.getItem('tc_theme')) || 'light';

export default createStore({
  state: {
    theme: savedTheme, // 'light' | 'dark'
    subscription: {
      active: false,
      plan: null, // 'monthly' | 'yearly'
      expiresAt: null,
      txnId: null,
    },
    internationalCharts: false, // controlled via Clerk private_metadata, off by default
    indianMarketData: false, // admin-controlled, off by default
    paymentLoading: false,
    paymentError: null,
  },

  getters: {
    isDarkTheme(state) {
      return state.theme === 'dark';
    },
    currentTheme(state) {
      return state.theme;
    },
    isSubscribed(state) {
      if (!state.subscription.active) return false;
      if (!state.subscription.expiresAt) return false;
      return new Date(state.subscription.expiresAt) > new Date();
    },
    subscriptionPlan(state) {
      return state.subscription.plan;
    },
    subscriptionExpiry(state) {
      return state.subscription.expiresAt;
    },
    internationalChartsEnabled(state) {
      return state.internationalCharts;
    },
    indianMarketDataEnabled(state) {
      return state.indianMarketData;
    },
  },

  mutations: {
    SET_THEME(state, theme) {
      state.theme = theme;
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('tc_theme', theme);
      }
    },
    SET_SUBSCRIPTION(state, { active, plan, expiresAt, txnId }) {
      state.subscription.active = active;
      state.subscription.plan = plan || null;
      state.subscription.expiresAt = expiresAt || null;
      state.subscription.txnId = txnId || null;
    },
    SET_INTERNATIONAL_CHARTS(state, enabled) {
      state.internationalCharts = !!enabled;
    },
    SET_INDIAN_MARKET_DATA(state, enabled) {
      state.indianMarketData = !!enabled;
    },
    SET_PAYMENT_LOADING(state, val) {
      state.paymentLoading = val;
    },
    SET_PAYMENT_ERROR(state, err) {
      state.paymentError = err;
    },
    CLEAR_SUBSCRIPTION(state) {
      state.subscription = {
        active: false,
        plan: null,
        expiresAt: null,
        txnId: null,
      };
      state.internationalCharts = false;
      state.indianMarketData = false;
    },
  },

  actions: {
    setTheme({ commit }, theme) {
      commit("SET_THEME", theme);
    },
    toggleTheme({ commit, state }) {
      const newTheme = state.theme === 'dark' ? 'light' : 'dark';
      commit("SET_THEME", newTheme);
    },
    activateSubscription({ commit }, { plan, expiresAt, txnId, internationalCharts, indianMarketData }) {
      commit("SET_SUBSCRIPTION", {
        active: true,
        plan,
        expiresAt,
        txnId,
      });
      commit("SET_INTERNATIONAL_CHARTS", !!internationalCharts);
      commit("SET_INDIAN_MARKET_DATA", !!indianMarketData);
    },
    setInternationalCharts({ commit }, enabled) {
      commit("SET_INTERNATIONAL_CHARTS", enabled);
    },
    setIndianMarketData({ commit }, enabled) {
      commit("SET_INDIAN_MARKET_DATA", enabled);
    },
    clearSubscription({ commit }) {
      commit("CLEAR_SUBSCRIPTION");
    },
  },
})
